import script from "./copy.vue?vue&type=script&setup=true&lang=js"
export * from "./copy.vue?vue&type=script&setup=true&lang=js"

import "./copy.vue?vue&type=style&index=0&id=b72ad1fe&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b72ad1fe"]])

export default __exports__